import { Controller } from "stimulus";

export default class extends Controller {
  submit(event) {
    event.preventDefault();
    const formElement = event.target;
    const submitButton = formElement.querySelector('[type="submit"]');

    document.getElementById('loader').style.display = 'flex';
    document.getElementById('backdrop').style.display = 'block';
    if (submitButton) submitButton.disabled = true;

    fetch(formElement.action, {
      method: 'POST',
      body: new FormData(formElement),
      dataType: 'script',
      headers: {
        'Accept': 'text/html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
    })
    .then(response => {
      if (!response.ok) throw new Error(`Report request failed (${response.status})`);
      return response.text();
    })
    .then(html => {
      const output = document.getElementById('output_report');
      output.innerHTML = html;
      output.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })
    .catch(() => {
      document.getElementById('output_report').innerHTML = '<div class="alert alert-danger" role="alert"><strong>We could not generate this report.</strong> Please check the filters and try again.</div>';
    })
    .finally(() => {
      document.getElementById('loader').style.display = 'none';
      document.getElementById('backdrop').style.display = 'none';
      if (submitButton) submitButton.disabled = false;
    });
  }
}
